"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const defaultMaxWidth = 192;
const ItemContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "NavigationItem__ItemContainer",
  componentId: "components-web__sc-ql9x7c-0"
})(_ref => {
  let {
    targetWidth
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: `${Math.max(defaultMaxWidth, targetWidth ?? 0)}px`,
    flexGrow: targetWidth ? 1 : 0,
    flexShrink: 1
  };
});

/**
 * NavigationItem within a NavigationBar component.
 *
 * This is rendered automatically by `NavigationBar` and isn't intended be used directly.
 */
const NavigationItem = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    accessibilityRole = 'link',
    // @todo switch to 'button' for dropdowns
    children,
    id,
    onClick: handleClick = () => {},
    selected = false,
    accessibilityState = {
      current: selected ? 'page' : false
    },
    href,
    tokens,
    variant = {},
    LinkRouter,
    linkRouterProps,
    ...rest
  } = _ref2;
  const selectedProps = selectProps(rest);
  const targetWidth = (0, _componentsBase.useResponsiveProp)({
    xs: 288,
    lg: null
  });
  const viewport = (0, _componentsBase.useViewport)();
  const getTokens = (0, _componentsBase.useThemeTokensCallback)('NavigationBar', tokens, variant);
  const getStateTokens = state => getTokens({
    ...state,
    viewport
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemContainer, {
    targetWidth: targetWidth,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Button, {
      accessibilityRole: accessibilityRole,
      accessibilityState: accessibilityState,
      onPress: handleClick,
      ref: ref,
      tokens: getStateTokens,
      variant: {
        selected
      },
      href: href,
      LinkRouter: LinkRouter,
      linkRouterProps: linkRouterProps,
      ...selectedProps,
      children: children
    })
  });
});
NavigationItem.displayName = 'NavigationItem';
NavigationItem.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _componentsBase.getTokensPropType)('NavigationBar'),
  onClick: _propTypes.default.func,
  selected: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired
};
var _default = exports.default = NavigationItem;